"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledRegularLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const linkConfig = {
  content: {
    fontFamily: _BaseTheme.default.type.family.content,
    lineHeight: _BaseTheme.default.type.lineHeight.regular
  },
  system: {
    fontFamily: _BaseTheme.default.type.family.system,
    lineHeight: _BaseTheme.default.type.lineHeight.regular
  },
  small: {
    fontFamily: _BaseTheme.default.type.family.system,
    fontSize: _BaseTheme.default.type.size.tiny,
    lineHeight: _BaseTheme.default.type.lineHeight.extra
  }
};
const StyledLink = (0, _styledComponents.css)(["font-family:", ";font-size:", ";line-height:", ";color:", ";cursor:pointer;text-decoration:none;&:hover{text-decoration:underline;}"], _ref => {
  let {
    type
  } = _ref;
  return linkConfig[type].fontFamily;
}, _ref2 => {
  let {
    type
  } = _ref2;
  return linkConfig[type].fontSize;
}, _ref3 => {
  let {
    type
  } = _ref3;
  return linkConfig[type].lineHeight;
}, _BaseTheme.default.colors.blue);
const StyledReactRouterDomLink = (0, _styledComponents.default)(_reactRouterDom.Link).withConfig({
  displayName: "InternalLink__StyledReactRouterDomLink",
  componentId: "design-system__sc-61ka2t-0"
})(["", ";"], StyledLink);

const StyledRegularLink = _styledComponents.default.a.withConfig({
  displayName: "InternalLink__StyledRegularLink",
  componentId: "design-system__sc-61ka2t-1"
})(["", ";"], StyledLink);

exports.StyledRegularLink = StyledRegularLink;

const InternalLink = _ref4 => {
  let {
    children,
    type,
    to,
    onClick
  } = _ref4,
      rest = _objectWithoutProperties(_ref4, ["children", "type", "to", "onClick"]);

  if (to) {
    return /*#__PURE__*/_react.default.createElement(StyledReactRouterDomLink, _extends({
      to: to,
      type: type,
      onClick: onClick
    }, rest), children);
  }

  const handleClick = e => {
    e.preventDefault();
    onClick(e);
  };

  return /*#__PURE__*/_react.default.createElement(StyledRegularLink, _extends({
    href: "#",
    type: type,
    onClick: handleClick
  }, rest), children);
};

InternalLink.propTypes = {
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func]),
  type: _propTypes.default.oneOf(['content', 'system', 'small']),
  children: _propTypes.default.node.isRequired,
  onClick: _propTypes.default.func
};
InternalLink.defaultProps = {
  type: 'system',
  onClick: () => {},
  to: undefined
};
var _default = InternalLink;
exports.default = _default;